import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ClientLayout from "../../component/appLayouts/clientLayout/clientLayout";
import DevisService from "../../services/devis.service";
import { getUserByID } from "../../services/user.service";
import DataTableDisplay from "../../component/ListeDevis/ListeDevis";
import { Card, Row, Col } from "react-bootstrap";
import "./index.scss";
import { useAuth } from "../../component/authProvider";
import ArrowBack from "../../component/icons/arrowBack";
import SimulationService from "../../services/simulations.service";
import { FaCog, FaEnvelope, FaEuroSign } from "react-icons/fa";
const simulationService = new SimulationService();
const SimulationDetails = () => {
  const { id } = useParams(); // l'ID de l'utilisateur
  const [user, setUser] = useState(null);
  console.log(user);
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const fetchUserDevis = async () => {
    setLoading(true);

    try {
      console.log("🚀 ~ fetchUserDevis ~ currentUser:", currentUser);

      const res = await simulationService.getSimulation(id); // <-- fetch all devis
      console.log("🚀 ~ fetchUserDevisgg ~ res:", res);
      setUser(res?.data);
    } catch (error) {
      console.error(error); // Log the error for debugging
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUserDevis();
  }, [id]);

  if (!user) return <p>Chargement...</p>;

  return (
    <>
      <div className="d-lg-flex justify-content-between my-4">
        <h5 className="text-black">
          <Link
            className="text-black text-capitalize"
            onClick={() => navigate(-1)}>
            <ArrowBack />
            Détails de la simulation
          </Link>
        </h5>
      </div>
      <div className="user-details">
        <Card className="user-details-card shadow-sm">
          <h3>Détails de la simulation fr</h3>
          <Card.Body>
            <Row>
              {/* Bloc 1 : Finances */}
              <Col md={4}>
                <h5 className="section-title text-primary">
                  <FaEuroSign className="me-2" />
                  Finances
                </h5>
                <ul className="info-list">
                  <li>
                    <strong>Frais Gestion € :</strong>{" "}
                    {user?.fraisGestionEuroFr}
                  </li>
                  <li>
                    <strong>Base Disponible :</strong> {user?.baseDisponibleFr}
                  </li>
                  <li>
                    <strong>Salaire Brut :</strong> {user?.salaireBrutFr}
                  </li>

                  <li>
                    <strong>Salaire Net :</strong> {user?.salaireNetFr}
                  </li>
                  <li>
                    <strong>Net Optimisé :</strong> {user?.salaireNetOptimiseFr}
                  </li>
                </ul>
              </Col>

              {/* Bloc 2 : Résumé */}
              <Col md={4}>
                <h5 className="section-title text-success">
                  <FaEnvelope className="me-2" />
                  Résumé
                </h5>
                <ul className="info-list">
                  <li>
                    <strong>Contact :</strong> {user?.contact?.email}
                  </li>
                  <li>
                    <strong>Configuration :</strong>
                    {user?.configFr && "FR"}
                  </li>
                  <li>
                    <strong>CA HT :</strong> {user?.chiffreAffairesHT}
                  </li>
                  <li>
                    <strong>Frais Pro :</strong> {user?.fraisProfessionnels}
                  </li>
                  <li>
                    <strong>Chargement Mission :</strong>{" "}
                    {user?.chargementMission}
                  </li>
                </ul>
              </Col>

              {/* Bloc 3 : Paramètres */}
              <Col md={4}>
                <h5 className="section-title text-warning">
                  <FaCog className="me-2" />
                  Paramètres
                </h5>
                <ul className="info-list">
                  <li>
                    <strong>Frais Gestion % :</strong>{" "}
                    {user?.fraisGestionEuroFr}
                  </li>

                  <li>
                    <strong>Taux Salariales % :</strong>{" "}
                    {user?.tauxChargesSalarialesPctFr}
                  </li>
                </ul>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <Card className="user-details-card shadow-sm mt-3">
          <h3>Détails de la simulation uk</h3>
          <Card.Body>
            <Row>
              {/* Bloc 1 : Finances */}
              <Col md={4}>
                <h5 className="section-title text-primary">
                  <FaEuroSign className="me-2" />
                  Finances
                </h5>
                <ul className="info-list">
                  <li>
                    <strong>Frais Gestion € :</strong>{" "}
                    {user?.fraisGestionEuroUk}
                  </li>
                  <li>
                    <strong>Base Disponible :</strong> {user?.baseDisponibleUk}
                  </li>
                  <li>
                    <strong>Salaire Brut :</strong> {user?.salaireBrutUk}
                  </li>

                  <li>
                    <strong>Salaire Net :</strong> {user?.salaireNetUk}
                  </li>
                  <li>
                    <strong>Net Optimisé :</strong> {user?.salaireNetOptimiseUk}
                  </li>
                  <li>
                    <strong>Pourcentage Salaire Brut Uk % :</strong>{" "}
                    {user?.pourcentageSalaireBrutUk}
                  </li>
                </ul>
              </Col>

              {/* Bloc 2 : Résumé */}
              <Col md={4}>
                <h5 className="section-title text-success">
                  <FaEnvelope className="me-2" />
                  Résumé
                </h5>
                <ul className="info-list">
                  <li>
                    <strong>Contact :</strong> {user?.contact?.email}
                  </li>
                  <li>
                    <strong>Configuration :</strong>
                    {user?.configUk && "UK"}
                  </li>
                  <li>
                    <strong>CA HT :</strong> {user?.chiffreAffairesHT}
                  </li>
                  <li>
                    <strong>Frais Pro :</strong> {user?.fraisProfessionnels}
                  </li>
                  <li>
                    <strong>Chargement Mission :</strong>{" "}
                    {user?.chargementMission}
                  </li>
                </ul>
              </Col>

              {/* Bloc 3 : Paramètres */}
              <Col md={4}>
                <h5 className="section-title text-warning">
                  <FaCog className="me-2" />
                  Paramètres
                </h5>
                <ul className="info-list">
                  <li>
                    <strong>Frais Gestion % :</strong>{" "}
                    {user?.fraisGestionEuroUk}
                  </li>

                  <li>
                    <strong>Taux Salariales % :</strong>{" "}
                    {user?.tauxChargesSalarialesPctUk}
                  </li>
                </ul>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <Card className="user-details-card shadow-sm mt-3">
          <h3>Détails de la simulation luk</h3>
          <Card.Body>
            <Row>
              {/* Bloc 1 : Finances */}
              <Col md={4}>
                <h5 className="section-title text-primary">
                  <FaEuroSign className="me-2" />
                  Finances
                </h5>
                <ul className="info-list">
                  <li>
                    <strong>Frais Gestion € :</strong>{" "}
                    {user?.fraisGestionEuroLux}
                  </li>
                  <li>
                    <strong>Base Disponible :</strong> {user?.baseDisponibleLux}
                  </li>
                  <li>
                    <strong>Salaire Brut :</strong> {user?.salaireBrutLux}
                  </li>
                  <li>
                    <strong>Charges Patronales € :</strong>{" "}
                    {user?.chargesPatronalesEuroLux}
                  </li>
                  <li>
                    <strong>Charges Salariales € :</strong>{" "}
                    {user?.chargesSalarialesEuroLux}
                  </li>
                  <li>
                    <strong>Salaire Net :</strong> {user?.salaireNetLux}
                  </li>
                  <li>
                    <strong>Net Optimisé :</strong>{" "}
                    {user?.salaireNetOptimiseLux}
                  </li>
                  <li>
                    <strong>Pourcentage Salaire Brut Lux % :</strong>{" "}
                    {user?.pourcentageSalaireBrutLux}
                  </li>
                </ul>
              </Col>

              {/* Bloc 2 : Résumé */}
              <Col md={4}>
                <h5 className="section-title text-success">
                  <FaEnvelope className="me-2" />
                  Résumé
                </h5>
                <ul className="info-list">
                  <li>
                    <strong>Contact :</strong> {user?.contact?.email}
                  </li>
                  <li>
                    <strong>Configuration :</strong>
                    {user?.configLux ? "LUX" : "Non défini"}
                  </li>
                  <li>
                    <strong>CA HT :</strong> {user?.chiffreAffairesHT}
                  </li>
                  <li>
                    <strong>Frais Pro :</strong> {user?.fraisProfessionnels}
                  </li>
                  <li>
                    <strong>Chargement Mission :</strong>{" "}
                    {user?.chargementMission}
                  </li>
                </ul>
              </Col>

              {/* Bloc 3 : Paramètres */}
              <Col md={4}>
                <h5 className="section-title text-warning">
                  <FaCog className="me-2" />
                  Paramètres
                </h5>
                <ul className="info-list">
                  <li>
                    <strong>Frais Gestion % :</strong>{" "}
                    {user?.fraisGestionPctLux}
                  </li>
                  <li>
                    <strong>Taux Patronales % :</strong>{" "}
                    {user?.tauxChargesPatronalesPctLux}
                  </li>
                  <li>
                    <strong>Taux Salariales % :</strong>{" "}
                    {user?.tauxChargesSalarialesPctLux}
                  </li>
                </ul>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default SimulationDetails;
